/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import * as Actions from "actions";
import { toast } from "react-toastify";

// Import Swiper styles
import 'swiper/swiper.min.css';
import './UserTryOnHistorySlider.scss';

// import Custom Components
import UserTryOnItem from "components/elements/user/tryon/UserTryOnItem";
import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import {getURI, isFeatureSupported} from "helpers/utils";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

const UserTryOnHistorySlider = (props) => {
  const {
    tryons, getTryOnHistory, deleteTryOn, isLoading
  } = props;

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [tryonToDelete, setTryonToDelete] = useState(null);

  useEffect(() => {
    getTryOnHistory();
  }, [getTryOnHistory]);

  const breakpoints = {
    300: {
      slidesPerView: 2.0,
      spaceBetween: 20,
    },
    340: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    380: {
      slidesPerView: 2.4,
      spaceBetween: 20,
    },
    420: {
      slidesPerView: 2.6,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2.8,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  };

  const handleDeleteClick = (tryonId) => {
    setTryonToDelete(tryonId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (tryonToDelete) {
      deleteTryOn({ tryonId: tryonToDelete });
      setDeleteDialogOpen(false);
      setTryonToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setTryonToDelete(null);
  };

  const renderResults = () => (
    <Container>
      <CustomSectionCreator 
        icon={<PeopleAltIcon sx={{ color: '#E53E3E', mr: 1 }} />} 
        title='My Virtual Try-Ons' 
        seeLink={getURI(process.env.REACT_APP_TYPE, "mytryons", "")}
        seeMoreLinkTitle="View more" 
        seeMoreLink={getURI(process.env.REACT_APP_TYPE, "mytryons", "")}
      />
      <swiper-container 
        slides-per-view="1.8" 
        space-between="4" 
        free-mode="true" 
        breakpoints={JSON.stringify(breakpoints)}
      >
        {tryons.map((tryon, index) => (
          <swiper-slide key={tryon._id || index}>
            <Box sx={{ width: 150 }}>
              <UserTryOnItem
                tryon={tryon}
                isDirect={true}
                 link={isFeatureSupported("shopreels") ? getURI(process.env.REACT_APP_TYPE, "mytryons", "") + "?ls=1&li=" + index : ""}
                /* onDelete={handleDeleteClick} delete not allowed */
              />
            </Box>
          </swiper-slide>
        ))}
      </swiper-container>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
        <DialogTitle>Delete Try-On</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this virtual try-on? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );

  return (
    <>
      {isLoading ? <MockProductBox />
        : tryons && tryons.length > 0
          ? renderResults()
          : ""}
    </>
  );
};

UserTryOnHistorySlider.propTypes = {
  tryons: PropTypes.arrayOf(PropTypes.object).isRequired,
  getTryOnHistory: PropTypes.func.isRequired,
  deleteTryOn: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

UserTryOnHistorySlider.defaultProps = {
  isLoading: false,
};

// Mapping Props and State.
const UserTryOnHistorySliderComponent = connect(
  ({ userbootupInfo, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userbootupInfo?.reqStatus,
    isLoading: userbootupInfo?.isLoading || false,
    serviceError: userbootupInfo?.serviceError,
    tryons: userbootupInfo?.tryonHistory?.history || [],
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserTryOnHistorySlider);

export default UserTryOnHistorySliderComponent;
